import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { moveToType, Pokemon } from "./FactoryTypes";
import {
  faCheck,
  faThumbTack,
  faThumbTackSlash,
  faUserAltSlash,
  faUserGroup,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

type FactoryPokemonProps = {
  pokemon: Pokemon;
  setPinned: (name: string) => void;
  setMyPokemon: (name: string) => void;
  setBlacklisted: (name: string) => void;
  myPokemon?: boolean;
  pinned?: boolean;
  blacklisted?: boolean;
};

export const FactoryPokemon = ({
  pokemon,
  setPinned,
  setMyPokemon,
  setBlacklisted,
  pinned,
  myPokemon,
  blacklisted,
}: FactoryPokemonProps) => {
  return (
    <div className={`pokemon${myPokemon ? " my-pokemon" : ""}${blacklisted ? " blacklisted" : ""}`}>
      <p className="name">
        {pokemon.species} {pokemon.set}
        <button
          onClick={() => setMyPokemon(`${pokemon.species} ${pokemon.set}`)}
          type="button"
          aria-label={`${myPokemon ? "Remove from team: " : "Add to team: "} ${pokemon.species} ${pokemon.set}`}
          className="my-pokemon-button"
        >
          <FontAwesomeIcon icon={myPokemon ? faUserAltSlash : faUserGroup} size={"lg"} />
        </button>
        <button
          onClick={() => setBlacklisted(`${pokemon.species} ${pokemon.set}`)}
          type="button"
          aria-label={`${blacklisted ? "Unblacklist" : "Blacklist"} ${pokemon.species} ${pokemon.set}`}
          className="blacklist-button"
        >
          <FontAwesomeIcon icon={blacklisted ? faCheck : faXmark} size={"lg"} />
        </button>
        {!myPokemon && (
          <button
            onClick={() => setPinned(`${pokemon.species} ${pokemon.set}`)}
            type="button"
            aria-label={`${pinned ? "Unpin" : "Pin"} ${pokemon.species} ${pokemon.set}`}
            className="pin-button"
          >
            <FontAwesomeIcon icon={pinned ? faThumbTackSlash : faThumbTack} size={"lg"} />
          </button>
        )}
      </p>
      <div className="pokemon-contents">
        <div className="left">
          <p>{pokemon.item}</p>
          <p className={`move ${moveToType[pokemon.move1].toLowerCase()}`}>
            {pokemon.move1} {pokemon.style[0] === "0" ? "" : ` ${pokemon.style[0]}`}
          </p>
          <p className={`move ${moveToType[pokemon.move3].toLowerCase()}`}>
            {pokemon.move3} {pokemon.style[4] === "0" ? "" : ` ${pokemon.style[4]}`}
          </p>
          <p>{pokemon.nature}</p>
        </div>
        <div className="right">
          <p className="abilities">{pokemon.abilities}</p>
          <p className={`move ${moveToType[pokemon.move2].toLowerCase()}`}>
            {pokemon.move2} {pokemon.style[2] === "0" ? "" : ` ${pokemon.style[2]}`}
          </p>
          <p className={`move ${moveToType[pokemon.move4].toLowerCase()}`}>
            {pokemon.move4} {pokemon.style[6] === "0" ? "" : ` ${pokemon.style[6]}`}
          </p>
          <p>{pokemon.evs}</p>
        </div>
      </div>
    </div>
  );
};
